import React from "react";
import styles from "./ToiPageHeader.module.css";
import toiLogoDark from "../../assets/img/toi/updatedLanding/toi-logo-dark.svg";
import toiLogoLight from "../../assets/img/toi/updatedLanding/toi-logo-light.svg";
import aboundLogoDark from "../../assets/img/toi/updatedLanding/abound-logo-dark.svg";
import aboundLogoLight from "../../assets/img/toi/updatedLanding/abound-logo-light.svg";

function ToiPageHeader({
  logo,
  logoAlt = "",
  onBack = () => {},
  rightContent = null,
  theme = "light",
  showBackButton = true,
}) {
  const isLight = (theme || "").toLowerCase() === "light";
  const toiLogo = isLight ? toiLogoLight : toiLogoDark;
  const aboundLogo = isLight ? aboundLogoLight : aboundLogoDark;

  return (
    <>
      <div className={styles.headerSpacer} aria-hidden="true" />
      <header className={styles.brandBar} data-theme={theme}>
        <div className={styles.headerLeft}>
          {showBackButton ? (
            <button
              type="button"
              className={styles.backButton}
              onClick={onBack}
              aria-label="Go back"
            >
              <span className={styles.backArrow} />
            </button>
          ) : null}
        </div>

        <div className={styles.brandCluster}>
          {logo ? (
            <img src={logo} alt={logoAlt} className={styles.headerLogo} />
          ) : (
            <div className={styles.brandLockup} aria-label="The Times of India x Abound">
              <img src={toiLogo} alt="The Times of India" className={styles.toiLogo} />
              <span className={styles.brandCross}>x</span>
              <img src={aboundLogo} alt="Abound" className={styles.aboundLogo} />
            </div>
          )}
        </div>

        {rightContent ? (
          <div className={styles.headerRight}>{rightContent}</div>
        ) : (
          <div className={styles.headerRight} aria-hidden="true" />
        )}
      </header>
    </>
  );
}

export default ToiPageHeader;
